/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-04-21 17:27:16
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-07-29 13:59:08
 * @FilePath: \oweFront\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
	createApp
} from 'vue'
import {
	ElConfigProvider,
	ElMessage,
	ElMessageBox,
	ElCarousel,
	ElCarouselItem,
	ElProgress,
	ElInput,
	ElRadio,
	ElRadioGroup,
	ElCheckbox,
	ElCheckboxGroup,
	ElTree,
	ElButton,
	ElSwitch,
	ElImage,
	ElDialog,
	ElTable,
	ElPagination,
	ElForm,
	ElSelect,
	ElDatePicker,
	ElPopconfirm,
	ElUpload,
	ElIcon,
	ElSlider,
	ElPopover,

} from "element-plus";

import 'element-plus/dist/index.css'
import "@/assets/css/reset.css";
import "@/assets/css/common.css";
import "@/assets/css/list.css";
import "@/assets/css/globalManage.css";
import "@/assets/css/admin.css";
import '@/assets/fonts/iconfont.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import App from './App.vue'
import router from "./router";
import store from "./store";
import mitt from "mitt";
import storage from "good-storage";
import request from "./libs/axios"; // 全局请求
import * as echarts from 'echarts';
//按钮权限控制方法
import btnPerms from "./btnPerms";
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
const app = createApp(App);
app.config.globalProperties.$message = ElMessage; // 自定义添加
app.config.globalProperties.$storage = storage; // 自定义添加
app.config.globalProperties.$http = request; // 自定义添加
app.config.globalProperties.$ctxPath = 'http://www.jiud.com.cn/'; // 自定义添加
app.config.globalProperties.$bus = mitt(); // 自定义添加
app.config.globalProperties.$echarts = echarts
app.use(ElMessage)
	.use(ElMessageBox)
	.use(ElCarousel)
	.use(ElCarouselItem)
	.use(ElProgress)
	.use(ElInput)
	.use(ElRadio)
	.use(ElRadioGroup)
	.use(ElCheckbox)
	.use(ElCheckboxGroup)
	.use(ElTree)
	.use(ElButton)
	.use(ElSwitch)
	.use(ElImage)
	.use(ElDialog)
	.use(ElTable)
	.use(ElPagination)
	.use(ElDatePicker)
	.use(ElForm)
	.use(ElSelect)
	.use(ElPopconfirm)
	.use(ElUpload)
	.use(ElIcon)
	.use(ElConfigProvider)
	.use(ElSlider)
	.use(ElPopover)

app.use(store).use(router);
app.use(Viewer, {
	defaultOptions: {
		navbar: false,
		title: false,
		toolbar: {
			zoomIn: 1,
			zoomOut: 1,
			oneToOne: 1,
			reset: 1,
			rotateLeft: 1,
			rotateRight: 1,
			flipHorizontal: 1,
			flipVertical: 1,
		}
	}
})

app.use(VueVirtualScroller);
btnPerms(app)
app.mount("#app");